import { Box } from '@jfs/ui-new'
import { FC, useState } from 'react'
import { LayoutChangeEvent } from 'react-native'
import { GridProps, Grid as _Grid } from 'react-virtualized'
const Grid = _Grid as unknown as FC<GridProps>

interface GridViewPros {
  items: any[]
  itemMinWidth: number
  renderItem: any
  gridHeight: number
  rowHeight: number
}
export const GridView = ({ items, itemMinWidth, renderItem, gridHeight, rowHeight }: GridViewPros) => {
  const [containerWidth, setContainerWidth] = useState(100)
  const onLayout = ({
    nativeEvent: {
      layout: { width },
    },
  }: LayoutChangeEvent) => {
    setContainerWidth(width)
  }

  const columnCount = Math.floor(containerWidth / itemMinWidth) ?? 1
  console.log('Math.ceil(items?.length / columnCount)', Math.ceil(items?.length / columnCount))
  const arrSize = columnCount > 0 ? Math.ceil(items?.length / columnCount) : 0
  let formattedArray = Array(arrSize).fill([])

  formattedArray = formattedArray.map((item, index) => {
    return items.slice(columnCount * index, columnCount * (index + 1))
  })
  console.log('formattedArray', formattedArray)

  const cellRenderer = ({ columnIndex, rowIndex, key, style, ...props }) => {
    const index = rowIndex * columnCount + columnIndex
    return (
      <div key={key} style={style}>
        {renderItem({ index, item: items[index], ...props })}
      </div>
    )
  }
  return (
    <Box onLayout={onLayout} width={'100%'} nativeID={'emibankslist-wrapper'}>
      <Grid
        cellRenderer={cellRenderer}
        columnCount={columnCount}
        columnWidth={itemMinWidth}
        rowCount={formattedArray.length}
        rowHeight={rowHeight}
        width={containerWidth}
        height={gridHeight}
        containerStyle={{ borderBottomWidth: 0 }}
      />
    </Box>
  )
}
